import { z } from "zod";

export const simpleAssessmentSchema = z.object({
  id: z.number(),
  test_takers: z.number(),
  is_published: z.coerce.boolean(),
  created_at: z.coerce.date(),
  created_by: z.object({
    id: z.number(),
    name: z.string(),
    email: z.string().email(),
  }),
});

export type SimpleAssessment = z.infer<typeof simpleAssessmentSchema>;
